import api from './xano';

export type AcademyMember = Record<string, unknown>;

const academyMembersPath =
  process.env.REACT_APP_XANO_ACADEMY_MEMBERS_PATH ||
  'https://xigf-mkk6-7rkl.n7e.xano.io/api:LcGd7aid/academy_filter';

export const membersAPI = {
  getAcademyMembers: (academyName: string) =>
    api.get(academyMembersPath, {
      params: {
        academyname: academyName,
      },
    }),
  getTauserById: (tauserId: string) =>
    api.get(`/tauser/${encodeURIComponent(tauserId)}`),
  updateTauser: (tauserId: string, payload: Record<string, unknown>) =>
    api.patch(`/tauser/${encodeURIComponent(tauserId)}`, payload),
  deleteTauser: (tauserId: string) =>
    api.delete(`/tauser/${encodeURIComponent(tauserId)}`),
};

export const normalizeMembersPayload = (payload: any): AcademyMember[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};
